const translationsLocationTimes = {
  'de-DE': {
    showMore: 'Alle Termine anzeigen',
    showLess: 'Weniger zeigen',
    showMoreDates: 'Weitere Termine anzeigen',
  },
  'de-AT': {
    showMore: 'Alle Termine anzeigen',
    showLess: 'Weniger zeigen',
    showMoreDates: 'Weitere Termine anzeigen',
  },

  'pt-PT': {
    showMore: 'Mostrar todas as datas',
    showLess: 'Ver menos',
    showMoreDates: 'Mostrar mais datas',
  },

  es: {
    showMore: 'Mostrar todas las fechas',
    showLess: 'Ver menos',
    showMoreDates: 'Mostrar más fechas',
  },
  fr: {
    showMore: 'Afficher toutes les dates',
    showLess: 'Voir moins',
    showMoreDates: 'Voir plus de dates',
  },
  it: {
    showMore: 'Mostra tutte le date',
    showLess: 'Mostra meno',
    showMoreDates: 'Mostra altre date',
  },
  se: {
    showMore: 'Visa alla datum',
    showLess: 'Visa mindre',
    showMoreDates: 'Visa mer datum',
  },
  nl: {
    showMore: 'Toon alle data',
    showLess: 'Minder tonen',
    showMoreDates: 'Meer data tonen',
  },
};

module.exports = translationsLocationTimes;
